module.exports = __webpack_public_path__ + "img/caba_winter.d51eefde.svg";